export const handleAuxClick = "bct_handle_auxclick";
export const addMiniActions = "bct_add_mini_actions";
export const nitroJs = "bct_nitro_js_enabled";
export const trackExternalCallTime = "bct_track_external_call_time";
export const disableRequests = "bct_disable_requests";
export const enableDocReferrerDelay = "bct_enable_doc_referrer_delay";